import { Permission } from "@ticketingplatform/api/dist/__generated__/globalTypes";

export const ROUTE_PATHS = {
  Dashboard: "/",
  Login: "/login",
  Events: "/events/new",
  EventCreate: "/events/:type/new",
  EventList: "/events",
  EventDetails: "/events/:id",
  EventEdit: "/events/:id/edit",
  RecuringEvents: "/recuring-events/new",
  RecuringEventCreate: "/recuring-events/:type/new",
  RecuringEventList: "/recuring-events",
  RecuringEventDetails: "/recuring-events/:id",
  VenuesList: "/venues",
  VenuesCreate: "/venues/new",
  VenueDetails: "/venues/:id",
  VenueEdit: "/venues/:id/edit",
  OrganizationsList: "/organizations",
  OrganizationDetails: "/organizations/:id",
  OrganizationEdit: "/organizations/:id/edit",
  OrganizationCreate: "/organizations/new",
  SettingsUsers: "/settings/users",
  SettingsUserDetails: "/settings/users/:id",
  SettingsUsersCreate: "/settings/users/new",
  SettingsUserEdit: "/settings/users/:id/edit",
  SettingsPayments: "/settings/payments",
  SettingsVenueUserList: "/settings/venue-users",
  SettingsVenueUserCreate: "/settings/venue-users/new",
  SettingsVenueUserEdit: "/settings/venue-users/:id/edit",
  PaymentTerminalsList: "/payment-terminals",
  PaymentTerminalCreate: "/payment-terminals/new",
  VenueLogin: "/venue-login",
  TicketTemplateList: "/ticket-templates",
  TicketTemplateCreate: "/ticket-templates/new",
  TicketTemplateEdit: "/ticket-templates/:id/edit",
  DiscountCodeList: "/discount-codes",
  DiscountCodeCreate: "/discount-codes/new",
  DiscountCodeEdit: "/discount-codes/:id/edit",
  Embed: "/settings/embed",
  OrderList: "/orders",
  OrderRead: "/orders/:id",
} as const;

export const ROUTE_TO_PERMISSIONS_MAP: Record<
  typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS],
  Permission[]
> = {
  [ROUTE_PATHS.Dashboard]: [],
  [ROUTE_PATHS.Login]: [],
  [ROUTE_PATHS.Events]: [Permission.EVENT_CREATE],
  [ROUTE_PATHS.EventDetails]: [Permission.EVENT_READ],
  [ROUTE_PATHS.EventList]: [Permission.EVENT_LIST, Permission.EVENT_READ],
  [ROUTE_PATHS.EventCreate]: [Permission.EVENT_CREATE],
  [ROUTE_PATHS.EventEdit]: [Permission.EVENT_UPDATE],
  [ROUTE_PATHS.RecuringEvents]: [Permission.EVENT_CREATE],
  [ROUTE_PATHS.RecuringEventDetails]: [
    Permission.EVENT_LIST,
    Permission.EVENT_READ,
  ],
  [ROUTE_PATHS.RecuringEventList]: [
    Permission.EVENT_LIST,
    Permission.EVENT_READ,
  ],
  [ROUTE_PATHS.RecuringEventCreate]: [Permission.EVENT_CREATE],
  [ROUTE_PATHS.VenuesList]: [Permission.VENUE_LIST, Permission.VENUE_READ],
  [ROUTE_PATHS.VenuesCreate]: [Permission.VENUE_CREATE],
  [ROUTE_PATHS.VenueDetails]: [Permission.VENUE_READ],
  [ROUTE_PATHS.VenueEdit]: [Permission.VENUE_UPDATE],
  [ROUTE_PATHS.OrganizationsList]: [
    Permission.ORGANIZATION_LIST,
    Permission.ORGANIZATION_READ,
  ],
  [ROUTE_PATHS.OrganizationDetails]: [Permission.ORGANIZATION_READ],
  [ROUTE_PATHS.OrganizationEdit]: [Permission.ORGANIZATION_UPDATE],
  [ROUTE_PATHS.OrganizationCreate]: [Permission.ORGANIZATION_CREATE],
  [ROUTE_PATHS.SettingsUsers]: [Permission.USER_LIST, Permission.USER_READ],
  [ROUTE_PATHS.SettingsUsersCreate]: [Permission.USER_CREATE],
  [ROUTE_PATHS.SettingsUserEdit]: [Permission.USER_UPDATE],
  [ROUTE_PATHS.SettingsUserDetails]: [Permission.USER_READ],
  [ROUTE_PATHS.SettingsPayments]: [],
  [ROUTE_PATHS.SettingsVenueUserList]: [Permission.VENUE_USER_LIST],
  [ROUTE_PATHS.SettingsVenueUserCreate]: [Permission.VENUE_USER_CREATE],
  [ROUTE_PATHS.SettingsVenueUserEdit]: [Permission.VENUE_USER_UPDATE],
  [ROUTE_PATHS.PaymentTerminalsList]: [Permission.PAYMENT_TERMINAL_LIST],
  [ROUTE_PATHS.PaymentTerminalCreate]: [Permission.PAYMENT_TERMINAL_CREATE],
  [ROUTE_PATHS.VenueLogin]: [],
  [ROUTE_PATHS.TicketTemplateList]: [Permission.TICKET_TEMPLATE_LIST],
  [ROUTE_PATHS.TicketTemplateCreate]: [Permission.TICKET_TEMPLATE_CREATE],
  [ROUTE_PATHS.TicketTemplateEdit]: [Permission.TICKET_TEMPLATE_UPDATE],
  [ROUTE_PATHS.DiscountCodeCreate]: [Permission.DISCOUNT_CODE_CREATE],
  [ROUTE_PATHS.DiscountCodeList]: [Permission.DISCOUNT_CODE_LIST],
  [ROUTE_PATHS.DiscountCodeEdit]: [Permission.DISCOUNT_CODE_UPDATE],
  [ROUTE_PATHS.Embed]: [Permission.SETTINGS_EMBED_READ],
  [ROUTE_PATHS.OrderList]: [Permission.ORDER_LIST],
  [ROUTE_PATHS.OrderRead]: [Permission.ORDER_READ],
};
